import { CAN_BYPASS_PAYMENT_EMAILS } from './const';

export default function canBypassPayment(user) {
    const email = user ? user.email : '';
    const emailDomain = email.substring(email.indexOf('@'), email.lenght);

    return CAN_BYPASS_PAYMENT_EMAILS.includes(emailDomain);
}
